import { createContext } from 'react';

export enum Modals {
  MAIN = 'MAIN',
  DOWNLOAD = 'DOWNLOAD',
  DONE = 'DONE',
}

export const ModalContext = createContext({
  currentOpenModal: Modals.MAIN,
  setCurrentModalOpen: (value: Modals) => {},
  onRequestClose: () => {},
});
